const EmotionalSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
          <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-2xl">
            <img
              src="https://public.readdy.ai/ai/img_res/86391e05e8a835f7da7dd0b9b0479f3c.jpg"
              alt="Processo di raccolta"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="space-y-6">
            <p className="text-[#2D5016] text-sm font-semibold uppercase tracking-wider">
              Il Nostro Processo
            </p>
            <h2 className="text-5xl font-serif text-[#2D5016] leading-tight">
              Dalla Pianta<br />alla Confezione
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              Ogni spezia che offriamo è il risultato di un processo attento e rispettoso della natura. 
              Dalla coltivazione biologica certificata alla raccolta manuale, ogni fase è curata con 
              dedizione per garantire la massima qualità e autenticità.
            </p>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-[#2D5016] rounded-full mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Coltivazione biologica certificata</span>
              </li>
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-[#2D5016] rounded-full mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Raccolta manuale al momento giusto</span>
              </li>
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-[#2D5016] rounded-full mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Lavorazione artigianale senza additivi</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-6 order-2 lg:order-1">
            <p className="text-[#2D5016] text-sm font-semibold uppercase tracking-wider">
              La Tradizione
            </p>
            <h2 className="text-5xl font-serif text-[#2D5016] leading-tight">
              Biscotti Artigianali<br />per Ogni Momento
            </h2>
            <p className="text-gray-600 text-lg leading-relaxed">
              I nostri biscotti biologici sono pensati per accompagnare le tue tisane e i tuoi momenti 
              di relax. Realizzati con ingredienti selezionati e ricette tradizionali, offrono un 
              equilibrio perfetto tra gusto e benessere.
            </p>
            <ul className="space-y-4">
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-[#2D5016] rounded-full mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Farine biologiche macinate a pietra</span>
              </li>
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-[#2D5016] rounded-full mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Ricette tradizionali rivisitate</span>
              </li>
              <li className="flex items-start">
                <div className="w-6 h-6 flex items-center justify-center bg-[#2D5016] rounded-full mr-3 mt-1 flex-shrink-0">
                  <i className="ri-check-line text-white text-sm"></i>
                </div>
                <span className="text-gray-700">Cottura artigianale in piccoli lotti</span>
              </li>
            </ul>
          </div>

          <div className="relative h-[500px] rounded-3xl overflow-hidden shadow-2xl order-1 lg:order-2">
            <img
              src="https://readdy.ai/api/search-image?query=artisan%20baker%20hands%20shaping%20organic%20cookie%20dough%20on%20wooden%20table%20with%20flour%20dust%20in%20air%2C%20warm%20kitchen%20lighting%20with%20rustic%20ambiance%2C%20close%20up%20showing%20craftsmanship%20and%20traditional%20baking%20techniques%2C%20cinematic%20food%20photography%20with%20natural%20warm%20tones%20and%20authentic%20textures&width=800&height=600&seq=emotion2&orientation=landscape"
              alt="Preparazione biscotti"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-24">
          <div className="relative h-80 rounded-2xl overflow-hidden shadow-lg group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=close%20up%20of%20hands%20holding%20colorful%20organic%20spices%20in%20cupped%20palms%2C%20warm%20natural%20lighting%20with%20soft%20focus%20background%2C%20intimate%20moment%20showing%20connection%20with%20natural%20ingredients%2C%20artistic%20food%20photography%20with%20earthy%20warm%20tones%20and%20authentic%20textures&width=400&height=600&seq=gallery1&orientation=portrait"
              alt="Gallery 1"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[#2D5016]/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <p className="text-white text-center px-4 font-medium">Spezie Selezionate</p>
            </div>
          </div>

          <div className="relative h-80 rounded-2xl overflow-hidden shadow-lg group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=extreme%20close%20up%20macro%20shot%20of%20organic%20cinnamon%20sticks%20and%20powder%20showing%20detailed%20texture%20and%20natural%20patterns%2C%20soft%20natural%20lighting%20with%20shallow%20depth%20of%20field%2C%20artistic%20food%20photography%20with%20warm%20brown%20tones%20and%20authentic%20details&width=400&height=600&seq=gallery2&orientation=portrait"
              alt="Gallery 2"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[#2D5016]/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <p className="text-white text-center px-4 font-medium">Texture Naturali</p>
            </div>
          </div>

          <div className="relative h-80 rounded-2xl overflow-hidden shadow-lg group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=person%20enjoying%20moment%20of%20tasting%20organic%20herbal%20tea%20with%20closed%20eyes%20showing%20pleasure%20and%20relaxation%2C%20warm%20natural%20window%20lighting%20with%20soft%20focus%2C%20authentic%20lifestyle%20photography%20capturing%20emotional%20connection%20with%20natural%20products&width=400&height=600&seq=gallery3&orientation=portrait"
              alt="Gallery 3"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[#2D5016]/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <p className="text-white text-center px-4 font-medium">Momenti di Gusto</p>
            </div>
          </div>

          <div className="relative h-80 rounded-2xl overflow-hidden shadow-lg group cursor-pointer">
            <img
              src="https://readdy.ai/api/search-image?query=overhead%20flat%20lay%20of%20organic%20cookies%20arranged%20artistically%20with%20tea%20cup%20and%20natural%20ingredients%20on%20rustic%20wooden%20surface%2C%20warm%20natural%20lighting%20with%20soft%20shadows%2C%20minimalist%20food%20styling%20with%20earthy%20warm%20tones%20and%20authentic%20composition&width=400&height=600&seq=gallery4&orientation=portrait"
              alt="Gallery 4"
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-[#2D5016]/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
              <p className="text-white text-center px-4 font-medium">Biscotti Artigianali</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EmotionalSection;